export default __webpack_public_path__ + "static/media/google-logo.b1f2f95e.svg";